import { boxTextIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Desc = createIcon({
  displayName: 'Desc',
  paths: [
    'M213.333 128c-47.104 0-85.333 38.229-85.333 85.333v597.333c0 47.104 38.229 85.333 85.333 85.333h597.333c47.104 0 85.333-38.229 85.333-85.333v-597.333c0-47.104-38.229-85.333-85.333-85.333h-597.333zM810.667 213.333v597.333h-597.333v-597.333h597.333zM341.333 725.333h170.667c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-170.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM682.667 554.667h-341.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h341.333c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM341.333 384h341.333c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-341.333c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(boxTextIcon)
})
